import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import CategorySearchandFilter from '../../../Single Components/CategorySearchandFilter';
import { useSelector } from 'react-redux';
import { StockMoveAPIcall } from './ReportAPI';
import { getCurrentTime } from '../../../../Js/Date';
import { IconButton, Skeleton, Tooltip } from '@mui/material';
import ReactToPrint from '../../../Shared/print/ReactToPrint';
import { setStockMoveSigleView } from './ReportSlice';
import store from '../../../../Redux/store';
import { setFilterActive, set_Back_button_action } from '../../../Single Components/listSlice/filterCategorySlice';
import ExcelJS from "exceljs"
import TableListActionButtons from '../../../Single Components/ActionButtons/TableListActionButtons';

export const StockMove = () => {
  let navigate = useNavigate();
  const [symbol, setSymbol] = useState(null);
  const [filteredData, setFilteredData] = useState({});
  const [FormDataInfo, setFormDataInfo] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [printData, setPrintData] = useState(null);
  const handleBranchSelect = (selectedBranch) => {
    setSelectedBranch(selectedBranch); 
  
  };
  const decimalPosition = localStorage.getItem("decimalPosition");
  const decimalPositionStock = localStorage.getItem("decimalPositionStock");

  const stockMove = useSelector((state) => state?.ReportSlice?.StockMove)
  const {currencyDetails,tableLoading}=useSelector((state)=>state.mainDashBoardSlice)
  const filtereDataOptions = useSelector((state) => state.listCategory);
  const companyProfileData = useSelector((state) => state?.companyProfileSlice?.userValue);

  const handleDataFromChild = (data) => {
    setFormDataInfo(data)
  };
  const handleFilterChange = (updatedItems) => {
    setFilteredData(updatedItems);
  };
  const formatFilterInfo = (filters) => {
    const parts = [];
  
    if (filters?.fromDate && filters?.toDate) {
      parts.push(`As of ${filters?.fromDate} to ${filters?.toDate}`);
    }

    if (filters?.branchList) {
      parts.push(`Branch: ${filters?.branchList?.storeCode}-${filters?.branchList?.branchName}`);
    }
    if (filters?.location) {
      parts.push(`Branch: ${filters?.location?.name}`);
    }
   
    
    return parts; // Return the array directly
  };
  const downloadList = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Stock move report");
    sheet.properties.defaultRowHeight = 20;
  
    // Add header section
    const titleRow = sheet.addRow(["Stock move report"]);
    titleRow.font = { size: 18, bold: true };
    sheet.mergeCells('A1:H1');
    titleRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
  
    // Add additional header information
    const filterParts = formatFilterInfo(filteredData) || [];
  
    // Ensure filterParts is an array and iterate over it
    if (Array.isArray(filterParts)) {
      filterParts.forEach((part, index) => {
        const row = sheet.addRow([part]);
        row.font = { size: 15, bold: true };
        sheet.mergeCells(`A${index + 2}:H${index + 2}`);
        row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      });
    }
  
    // Add an empty row between header and table
    sheet.addRow([]);
  
    // Header row styling
    const headerRow = sheet.addRow(["Item", "UOM", "Opening", "In","Out","Closing","Cost","Values"]);
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1d1da7" }, // Use full hex code with "FF" prefix for better compatibility
    };
    const headerFont = {
      size: 15,
      bold: true,
      color: { argb: "FFFFFFFF" }, // White font color
    };
  
    headerRow.eachCell((cell) => {
      cell.fill = headerFill;
      cell.font = headerFont;
      cell.alignment = { vertical: 'middle', horizontal: 'center' }; // Ensure header text is centered
    });
  
    sheet.columns = [
      { header: "Item", key: "productName", width: 30 },
      { header: "UOM", key: "uom", width: 10 },
      { header: "Opening", key: "openingBalance", width: 15 },
      { header: "In", key: "totalInDate", width: 13 },
      { header: "Out", key: "totalOutDate", width: 13 },
      { header: "Closing", key: "closingBalance", width: 13},
      { header: "Cost", key: "cost", width: 13 },
      { header: "Stock Move Report", key: "value", width: 15 },
    ];
  
    stockMove?.forEach((item) => {
      const row = sheet.addRow({
        productName: item?.productName,
        uom: item?.uom,
        openingBalance: ` ${item?.openingBalance}`,
        totalInDate: ` ${item?.totalInDate?.toFixed(2)}`,
        totalOutDate: ` ${item?.totalOutDate?.toFixed(2)}`,
        closingBalance: ` ${item?.closingBalance?.toFixed(2)}`,
        cost: ` ${item?.cost?.toFixed(2)}`,
        value: ` ${item?.value?.toFixed(2)}`,
      });
  
      const rowFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFC3D4F7" }, // Use full hex code with "FF" prefix for better compatibility
      };
      
      row.eachCell((cell, colNumber) => {
        cell.fill = rowFill;
        cell.border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        if (colNumber >2) { // Right align all columns except the first
            cell.alignment = { horizontal: 'right' };
          }else{
            cell.alignment = { horizontal: 'center' };
          }
      });
    });
  
    // Add row for totals
    const totalRow = sheet.addRow([
      "Total",
      "",
      "",
      `${symbol} ${stockMove?.reduce((sum,item)=>sum+item?.totalInDate,0)?.toFixed(decimalPosition)}`,
      `${symbol} ${stockMove?.reduce((sum,item)=>sum+item?.totalOutDate,0)?.toFixed(decimalPosition)}`,
      `${symbol} ${stockMove?.reduce((sum,item)=>sum+item?.closingBalance,0)?.toFixed(decimalPosition)}`,
      `${symbol} ${stockMove?.reduce((sum,item)=>sum+item?.cost,0)?.toFixed(decimalPosition)}`,
      `${symbol} ${stockMove?.reduce((sum,item)=>sum+item?.value,0)?.toFixed(decimalPosition)}`,
    
      
      
      
      
     
    ]);
  
    totalRow.eachCell((cell,colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = headerFill;
      cell.border = {
        top: { style: "thin", color: { argb: "FFFFFFFF" } },
        left: { style: "thin", color: { argb: "FFFFFFFF" } },
        bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
        right: { style: "thin", color: { argb: "FFFFFFFF" } },
      };
      if (colNumber >1) { // Right align all columns except the first
        cell.alignment = { horizontal: 'right' };
      }
    });
  
    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "Stock Move Report.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const handleClickRow = (row) => {
    localStorage.setItem("vendor", row?.productName)
    localStorage.setItem("stock_id", row?._id);
    store.dispatch( setStockMoveSigleView({stockMoveSingleList:[]}))
    store.dispatch( setFilterActive(window.location.pathname))
    navigate("/userdashboard/inventory/reports/stockMove/singleView")
  }


  // 🚀 Ultra-Fast Print Function for Stock Move Report
  const handleFastPrint = async () => {
    // Use printData state which is synced when data is available
    const dataToPrint = printData || stockMove;
    
    console.log('🔍 Checking Stock Move data:', { 
      stockMove, 
      printData,
      dataToPrint,
      isArray: Array.isArray(dataToPrint), 
      length: dataToPrint?.length,
      tableLoading 
    });
    
    if (tableLoading) {
      console.error('❌ Data is still loading, please wait...');
      alert('Data is still loading. Please wait before printing.');
      return;
    }
    
    if (!dataToPrint || !Array.isArray(dataToPrint) || dataToPrint.length === 0) {
      console.error('❌ No Stock Move data available to print');
      alert('No data available to print. Please load the report first.');
      return;
    }

    try {
      console.log('🚀 Starting Stock Move Report Fast Print with', dataToPrint.length, 'items');

      // Create Stock Move HTML content
      const createStockMoveHTML = () => {
        const filterInfo = formatFilterInfo(filteredData);
        
        // Build table rows
        const tableRows = dataToPrint.map((item, index) => `
          <tr style="${index % 2 === 0 ? 'background-color: #f1f2f5;' : 'background-color: white;'}">
            <td style="text-align: left; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${item.productName || ''}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${item.uom || ''}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${Number(item.openingBalance || 0).toFixed(decimalPositionStock || 2)}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${Number(item.totalInDate || 0).toFixed(decimalPositionStock || 2)}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${Number(item.totalOutDate || 0).toFixed(decimalPositionStock || 2)}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${Number(item.closingBalance || 0).toFixed(decimalPosition || 2)}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${Number(item.cost || 0).toFixed(decimalPosition || 2)}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${Number(item.value || 0).toFixed(decimalPosition || 2)}</td>
          </tr>
        `).join('');

        // Calculate totals matching the main table
        const totalIn = dataToPrint.reduce((sum, item) => sum + (Number(item.totalInDate) || 0), 0);
        const totalOut = dataToPrint.reduce((sum, item) => sum + (Number(item.totalOutDate) || 0), 0);
        const totalClosing = dataToPrint.reduce((sum, item) => sum + (Number(item.closingBalance) || 0), 0);
        const totalCost = dataToPrint.reduce((sum, item) => sum + (Number(item.cost) || 0), 0);
        const totalValue = dataToPrint.reduce((sum, item) => sum + (Number(item.value) || 0), 0);

        return `
          <div style="font-family: Arial, sans-serif; padding: 20px; background-color: white;">
            <!-- Header Section -->
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; padding: 20px 0;">
              <!-- Left Side - Company Info -->
              <div style="width: 30%;">
                ${companyProfileData?.companyLogo ? `<img src="${companyProfileData?.companyLogo}" alt="Company Logo" style="max-width: 150px; margin-bottom: 10px; display: block;" />` : ''}
              </div>
              
              <!-- Center - Report Title -->
              <div style="width: 40%; text-align: center;">
                <h1 style="margin: 0; font-size: 20px; color: #333; font-weight: bold;">STOCK MOVE REPORT</h1>
                ${filterInfo.length > 0 ? `<p style="margin: 8px 0; font-size: 12px; color: #666;">${filterInfo.join(' | ')}</p>` : ''}
                <p style="margin: 5px 0; font-size: 11px; color: #888;">Generated: ${getCurrentTime()}</p>
              </div>
              
              <!-- Right Side - Company Details -->
              <div style="width: 30%; text-align: right;">
                <h2 style="margin: 0 0 8px 0; font-size: 14px; color: #333; font-weight: bold;">${companyProfileData?.companyName || ''}</h2>
                <p style="margin: 4px 0; font-size: 11px; color: #555;">${companyProfileData?.companyAddress || ''}</p>
                <p style="margin: 4px 0; font-size: 11px; color: #555;">${companyProfileData?.companyContact || ''}</p>
              </div>
            </div>

            <!-- Table -->
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              <thead>
                <tr style="background-color: #1d1da7; color: white; font-weight: bold;">
                  <th style="padding: 12px 8px; text-align: left; border: 1px solid #ddd; font-size: 12px;">Item</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">UOM</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">Opening</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">In</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">Out</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">Closing</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">Cost</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">Values</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
              <tfoot>
                <tr style="background-color: #1d1da7; color: white; font-weight: bold;">
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;" colspan="3">Total</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${totalIn.toFixed(decimalPosition || 2)}</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${totalOut.toFixed(decimalPosition || 2)}</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${totalClosing.toFixed(decimalPosition || 2)}</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${totalCost.toFixed(decimalPosition || 2)}</th>
                  <th style="padding: 12px 8px; text-align: right; border: 1px solid #ddd; font-size: 12px;">${symbol || ''} ${totalValue.toFixed(decimalPosition || 2)}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        `;
      };

      const stockMoveHTML = createStockMoveHTML();
      
      // Create print window
      const printWindow = window.open('', '_blank', 'width=1000,height=800');
      
      if (!printWindow) {
        console.error('Failed to open print window');
        return;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Stock Move Report</title>
          <style>
            @page { 
              size: A4 portrait; 
              margin: 15mm; 
            }
            body { 
              margin: 0; 
              padding: 15px; 
              font-family: Arial, sans-serif;
              font-size: 12px;
              line-height: 1.4;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            table {
              page-break-inside: auto;
              break-inside: auto;
            }
            tr { 
              page-break-inside: avoid;
              break-inside: avoid;
            }
            thead { 
              display: table-header-group;
            }
            tfoot {
              display: table-row-group; /* Show only at the end, not on every page */
            }
            tfoot tr {
              background-color: #1d1da7 !important;
              color: white !important;
              font-weight: bold !important;
              page-break-inside: avoid;
              break-inside: avoid;
            }
            @media print { 
              body { 
                margin: 0; 
                padding: 10px; 
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              tr { 
                page-break-inside: avoid;
                break-inside: avoid;
              }
              thead { 
                display: table-header-group;
              }
              tfoot {
                display: table-row-group; /* Show only at the end, not on every page */
              }
              tfoot tr {
                background-color: #1d1da7 !important;
                color: white !important;
                font-weight: bold !important;
                page-break-inside: avoid;
                break-inside: avoid;
              }
            }
          </style>
        </head>
        <body>
          ${stockMoveHTML}
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();
      console.log('✅ Stock Move Report Fast Print initiated successfully');

    } catch (error) {
      console.error('❌ Error in Stock Move Report fast print:', error);
    }
  };

  const handlePrint = handleFastPrint;
  useEffect(() => {
    setSymbol(currencyDetails?.symbol);
  }, [currencyDetails]);

  // Sync printData when stockMove data is available and not loading
  useEffect(() => {
    if (!tableLoading && stockMove && Array.isArray(stockMove) && stockMove.length > 0) {
      console.log('📦 Syncing print data with', stockMove.length, 'items');
      setPrintData(stockMove);
    }
  }, [stockMove, tableLoading]);

  useEffect(() => {
    if (FormDataInfo?.length !== 0) {
      localStorage.setItem("branch", (FormDataInfo?.branchList?.length === 0 ? '' : FormDataInfo?.branchList[0]))
      localStorage.setItem("location", FormDataInfo?.location?.length === 0 ? '' : FormDataInfo?.location[0])
      localStorage.setItem("fromDate", FormDataInfo?.fromDate)
      localStorage.setItem("ToDate", FormDataInfo?.toDate)

      let body = {
        fromDate: FormDataInfo.fromDate === '' ? '' : `${FormDataInfo.fromDate} 00:00:00`,
        endDate: FormDataInfo.toDate === '' ? '' : `${FormDataInfo.toDate} 23:59:59`,
        location: FormDataInfo?.location?.length === 0 ? '' : FormDataInfo?.location[0],
        branchId: FormDataInfo?.branchList?.length === 0 ? '' : FormDataInfo?.branchList[0],

        search: FormDataInfo?.search,
      }

    let loadData=window.location.pathname===filtereDataOptions?.filterActive
    !loadData && StockMoveAPIcall(body)
    }
  }, [FormDataInfo])


  return (
    <div className="global-page-parent-container updated-global-page-parent-container">
      <div className="justify-space-between list-create-head-bar">
        <h3>Stock Move Report</h3>
        <div className="create-head-buttons-container">
          <TableListActionButtons downloadClick={downloadList} PrintClick={handlePrint} disabled={tableLoading || (!printData && (!stockMove || stockMove.length === 0))}/>
          <CategorySearchandFilter
              statusOptions={['PURCHASE ORDER', 'DONE', 'CANCEL']}
              onData={handleDataFromChild}
              isLocation={true}
              onBranchSelect={handleBranchSelect}
              onFilterChange={handleFilterChange}
            />
        </div>
      </div>
      <div className="global-report-table-container updated-table-container" style={{height:"calc(100vh - 145px)"}}>
        <table style={{paddingTop:"4px"}}>
          <thead>
            <tr >
              <th>Item</th>
              <th>UOM</th>
              <th>Opening</th>
              <th>In</th>
              <th>Out</th>
              <th>Closing</th>
              <th>Cost</th>
              <th>Values</th>
            </tr>
          </thead>
          <tbody>
  {
    tableLoading ?
    ([...Array(10)].map((r, i) => (
      <tr key={i}>
        <td colSpan={10}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            width={"100%"}
            height={40}
          />
        </td>
      </tr>
    ))
    ) : stockMove !== undefined ?
    [...stockMove]?.reverse()?.map((item, index) => ( // Create a copy first with spread operator
      <tr
        style={{cursor:"pointer"}}
        key={index} 
        onClick={() => handleClickRow(item)}
      >
        <td style={{ textAlignLast: "start", paddingLeft: "10px" }}>{item.productName}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.uom}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.openingBalance}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.totalInDate?.toFixed(decimalPositionStock)}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.totalOutDate?.toFixed(decimalPositionStock)}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{item.closingBalance?.toFixed(decimalPosition)}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{symbol}&nbsp;{item.cost?.toFixed(decimalPosition)}</td>
        <td style={{ textAlignLast: "end", paddingRight: "10px" }}>{symbol}&nbsp;{item.value?.toFixed(decimalPosition)}</td>
      </tr>
    ))
    :
    <tr>
      <td colSpan={8}>No Records !!</td>
    </tr>
  }
</tbody>
          {
          !tableLoading&& stockMove!==undefined&& 
          <tfoot>
            <tr>
              <th colSpan={3}>Total</th>
              <th >{symbol}&nbsp;{(stockMove?.reduce((sum,item)=>sum+item?.totalInDate,0)?.toFixed(decimalPosition))}</th>
              <th >{symbol}&nbsp;{(stockMove?.reduce((sum,item)=>sum+item?.totalOutDate,0)?.toFixed(decimalPosition))}</th>
              <th >{symbol}&nbsp;{(stockMove?.reduce((sum,item)=>sum+item?.closingBalance,0)?.toFixed(decimalPosition))}</th>
              <th >{symbol}&nbsp;{(stockMove?.reduce((sum,item)=>sum+item?.cost,0)?.toFixed(decimalPosition))}</th>
              <th >{symbol}&nbsp;{(stockMove?.reduce((sum,item)=>sum+item?.value,0)?.toFixed(decimalPosition))}</th>
            </tr>
          </tfoot>}
        </table>
      </div>


          </div>
  )
}